import { SystemProps, Stack, Box, css } from '@storyofams/react-ui'
import { Image } from '@storyofams/storyblok-toolkit'
import SbEditable from 'storyblok-react'
import { SectionWrapper } from '~components/common/SectionWrapper'
import styled from 'styled-components'

import { DynamicpageItem } from '~lib/storyblok/sdk'
import { DynamicSectionContainer } from '..'
import { FixedRatio, RichText, Button } from '~components'
import { Flex } from '@storyofams/react-ui'

type TextImageProps = {
  content: DynamicpageItem['content']['sections']['text_image']['content']
  first?: boolean
} & SystemProps

export const TextImage = ({ content, first, ...props }: TextImageProps) => {
  const ConditionBasedPaddingBox = styled(Box)`
    @media screen and (min-width: 768px) {
      ${content?.reverse
        ? `padding-right: 0 !important;`
        : `padding-left: 0 !important;`}
    }
  `

  return (
    <SectionWrapper
      mdBgColor={!!content?.section_bg ? content?.section_bg?.color : ''}
      backgroundColor={!!content?.section_bg ? content?.section_bg?.color : ''}
    >
      <SbEditable content={content as any}>
        <DynamicSectionContainer
          px={{
            all: 0,
            md: 10,
            lg: 20,
          }}
          {...props}
        >
          <Stack
            pb={[4, 6]}
            pt={[0, 6]}
            space={[3, 10]}
            flexDirection={['column', content?.reverse ? 'row-reverse' : 'row']}
            justifyContent="center"
            alignItems="center"
            backgroundColor={
              !!content?.text_bg?.color ? content?.text_bg?.color : ''
            }
          >
            {!!content?.image && (
              <FixedRatio
                ratio={[
                  [327, 400],
                  [520, 480],
                ]}
                maxHeight="60vh"
                flex={1}
                width={['100%', 'auto']}
                css={css({
                  '.storyblok-image-wrapper': {
                    width: '100%',
                    height: '100%',
                  },
                })}
                bg={!!content?.text_bg?.color ? '#FFF' : ''}
              >
                <Image
                  width="100%"
                  height="100%"
                  src={content?.image.filename}
                  alt={content?.image.alt}
                  focus={content?.image.focus}
                  fluid={800}
                />
              </FixedRatio>
            )}

            {!!content?.text?.content?.[0]?.content?.[0]?.text && (
              <ConditionBasedPaddingBox
                flex={1}
                mx="auto"
                px={[2, 4]}
                maxWidth={!content?.image && 880}
              >
                {!!content?.text?.content?.[0]?.content?.[0]?.text && (
                  <RichText text={content?.text} />
                )}

                {!!content?.button_text && !!content?.button_link?.cached_url && (
                  <Box display={['block', 'block']}>
                    <Flex
                      mt={[1, 2]}
                      px={['5%', '5%', '0']}
                      width="100%"
                      justifyContent={'flex-start'}
                    >
                      <Button
                        width={['100%', 'auto']}
                        variant="button_type_1"
                        mt={'16px'}
                        mb={'16px'}
                        to={content?.button_link?.cached_url}
                      >
                        {content?.button_text}
                      </Button>
                    </Flex>
                  </Box>
                )}
              </ConditionBasedPaddingBox>
            )}
          </Stack>
        </DynamicSectionContainer>
      </SbEditable>
    </SectionWrapper>
  )
}
